// Angular dependencies
import { Injectable } from '@angular/core';

import { LocalStorageService, SocketService as SocketServiceLegacy, AuthService, ApiService } from '../core/upgraded-providers';
import SocketService from '../shared-services.module/socket.service';

import { Observable, } from 'rxjs';
import { tap, map, distinctUntilChanged } from 'rxjs/operators';

const LINE = 'l';
const CIRCLE = 'c';
const POLY = 'p';
const RECT = 'r';
const TEXT = 't';

@Injectable()
export class VisualService {
    _socket: SocketService;

    _shard: string;
    set shard(shard) {
        this._shard = shard;
    }
    get shard() {
        return this._shard;
    }

    constructor(
        private _apiSrv: ApiService,
        private _authSrv: AuthService,
        private _socketLegacy: SocketServiceLegacy,
        private _localStorageSrv: LocalStorageService
    ) {
        const url = this._socketLegacy.options.websocketUrl;
        const token = this._localStorageSrv.get('auth', null, '');

        this._socket = new SocketService({ url, token });
    }

    connect(shard: string): Observable<any> {
        const url = this._apiSrv.options.official ? `${ this._authSrv.Me._id }/${ shard }` : this._authSrv.Me._id;

        return this._socket.on(`mapVisual:${ url }`)
            .pipe(map<any, any>(({ data: [, objects] }) => objects))
            .pipe(distinctUntilChanged())
            .pipe(map((objects: string) => {
                return objects && objects
                    .split('\n')
                    .filter((_) => !!_)
                    .map((item) => {
                        return JSON.parse(item);
                    });
            }))
            .pipe(map((objects: any) => objects && objects.filter(validate)));
    }
}


function isString(v) {
    return typeof v === 'string';
}

function isNumber(v) {
    return typeof v === 'number';
}

function validatePoint(n, x, y): boolean {
    return isString(n) && isNumber(x) && isNumber(y);
}

function validateLine({ n1, x1, y1, n2, x2, y2 }): boolean {
    return validatePoint(n1, x1, y1) && validatePoint(n2, x2, y2);
}

function validateCircle({ n, x, y }): boolean {
    return validatePoint(n, x, y);
}

function validateRect({ n, x, y, w, h }): boolean {
    return validatePoint(n, x, y) && isNumber(w) && isNumber(h);
}

function validatePoly({ points }): boolean {
    if (!Array.isArray(points)) {
        return false;
    }

    return !points.some(({ n, x, y }) => !validatePoint(n, x, y));
}

function validateText({ n, x, y }) {
    return validatePoint(n, x, y);
}

function getObjectType({ t }) {
    switch (t) {
        case LINE: return 'line';
        case CIRCLE: return 'circle';
        case POLY: return 'polygon';
        case RECT: return 'rectangle';
        case TEXT: return 'text';
    }

    return undefined;
}

function validate(object) {
    let valid = true;

    switch (object.t) {
        case LINE:
            valid = validateLine(object);
            break;
        case CIRCLE:
            valid = validateCircle(object);
            break;
        case POLY:
            valid = validatePoly(object);
            break;
        case RECT:
            valid = validateRect(object);
            break;
        case TEXT:
            valid = validateText(object);
            break;
        default: valid = false;
    }

    if (!valid) {
        console.error(`Visual ${ getObjectType(object) } object is invalid`);
    }

    return valid;
}
